import React from "react";
import "./CSS/Categories.css";
import { Link, useNavigate } from "react-router-dom";

import crdbg from "./IMAGES/030baf24263fe4ae6abe7c3522b06880211742a7.png";
import saree from "./IMAGES/Category Saree.png";
import kurti from "./IMAGES/CategoryKurti.png";
import dresses from "./IMAGES/CategoryDress (1).png";
import blouse from "./IMAGES/Category Blouse.png";
import tops from "./IMAGES/CategoryTops.png";

const Categories = () => {
  const navigate = useNavigate();

  const data = [
    { title: "Saree", img: saree, bg: crdbg },
    { title: "Kurti Sets", img: kurti, bg: crdbg },
    { title: "Dresses", img: dresses, bg: crdbg },
    { title: "Tops", img: tops, bg: crdbg },
    { title: "Blouse", img: blouse, bg: crdbg },
  ];

  return (
    <div className="categories-container">
      <div className="categories-header">
        <div>
          <h1>Exclusive Categories</h1>
          <p>
            Explore our handcrafted collections, tailored for every generation.
          </p>
        </div>

        {/* <Link to="/shop" className="see-all">
          See all
        </Link> */}
      </div>

      <div className="categories-card-wrapper">
        {data.map((item, index) => (
          <div
            className="categories-card"
            key={index}
            onClick={() => navigate("/shop")}
            style={{ cursor: "pointer" }}
          >
            <div
              className="arch"
              style={
                {
                  // background: `url(${item.bg}) center / cover no-repeat`,
                }
              }
            >
              {/* <h3>{item.title}</h3> */}
              <img src={item.img} alt={item.title} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Categories;
